import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button } from '@material-ui/core';
import DeleteCapAct from '../../assets/DeleteCapAct';
import MoveCapAct from '../../assets/MoveCapAct';
import AddConfirmationJourney from './AddConfirmationJourney';
import Theme from '../ui/Theme';
const useStyles = makeStyles((theme) => ({
  footer: {
    background: Theme.palette.ternary.main,
    height: '72px',
    position: 'sticky',
    width: '100%',
    bottom: '0',
    color: 'black',
    fontSize: '25px',
    boxShadow: ' 0px 0px 16px rgba(0, 0, 0, 0.14)',
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    /* identical to box height */
    textAlign: 'center',
    color: '#FFFFFF',
  },
  saveButton: {
    width: '140px',
    height: '42px',
    background: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },

  moveButton: {
    width: '56px',
    height: '42px',
    background: theme.palette.secondary.main,
  },
}));
const CapstoneActivityFooter = (props) => {
  const classes = useStyles();
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const getButtonText = () => {
    if (props.leng > 0) {
      if (props.add === 0) {
        return 'Update';
      }
      return 'Save';
    }
    return 'Save';
  };
  const openConfirm = () => {
    setOpenConfirmation(true);
  };
  const closepopup = () => {
    setOpenConfirmation(false);
  };
  return (
    <footer className={classes.footer}>
      <Grid
        container
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
        style={{ padding: '14px 10px 16px 64px' }}
      >
        <Grid item>
          <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
            <Grid item>
              <Button
                className={classes.moveButton}
                onClick={openConfirm}
                style={{ marginRight: '12px' }}
                variant="text"
                startIcon={<DeleteCapAct />}
              />
            </Grid>
            <Grid item>
              <Button className={classes.moveButton} variant="text" startIcon={<MoveCapAct />} onClick={props.change} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Button className={classes.saveButton} variant="text" onClick={props.clickFn}>
            {getButtonText()}
          </Button>
        </Grid>
        {openConfirmation && <AddConfirmationJourney open close={closepopup} delFn={props.delFn} type="capAct" />}
      </Grid>
    </footer>
  );
};

export default CapstoneActivityFooter;
